import _ from 'lodash';
import flattenJSON from 'utils/flattenJSON';
import { decamelize } from 'humps'; // Note we don't use decamelizeKeys because it reaches into too far into the rich File objects

export default function buildFormDataFromNestedJSON(formValues, prefix = 'form') {
  const flattened = flattenJSON(formValues);

  if (_.isEmpty(flattened)) {
    // FIXME: Sending a blank FormData object to Rails seems to break things,
    // so if we have no data, we send an empty JSON object instead
    return {};
  } else {
    const formData = new FormData();
    _.each(flattened, (value, key) => {
      formData.append(decamelize(`${prefix}${key}`), value);
    });
    return formData;
  }
}
